const DATE_KEY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const MONTH_KEY_PATTERN = /^\d{4}-\d{2}$/;

function formatLocalDateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function formatDateLabel(dateKey) {
  if (!DATE_KEY_PATTERN.test(dateKey)) return dateKey;

  const weekdayNames = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  const date = new Date(`${dateKey}T00:00:00`);
  return `${date.getMonth() + 1}月${date.getDate()}日 ${weekdayNames[date.getDay()]}`;
}

function getMonthRange(monthKey) {
  const [year, month] = monthKey.split("-").map(Number);
  const start = new Date(year, month - 1, 1);
  const end = new Date(year, month, 0);
  return {
    date_from: formatLocalDateKey(start),
    date_to: formatLocalDateKey(end),
  };
}

export function buildDriverTimeOffDateRange({ orders = [], monthFilter = "", now = new Date() } = {}) {
  if (MONTH_KEY_PATTERN.test(monthFilter)) {
    return getMonthRange(monthFilter);
  }

  const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const currentMonthRange = getMonthRange(currentMonth);
  const orderDates = orders
    .map((order) => order.departure_date)
    .filter((date) => DATE_KEY_PATTERN.test(date))
    .sort();

  if (orderDates.length === 0) {
    return currentMonthRange;
  }

  return {
    date_from: [orderDates[0], currentMonthRange.date_from].sort()[0],
    date_to: [orderDates[orderDates.length - 1], currentMonthRange.date_to].sort().slice(-1)[0],
  };
}

export function mergeDriverTimeOffGroups(
  groupedOrders = [],
  driverTimeOffByDate = {},
  { includeTimeOffOnlyDates = true, hidePastTimeOffOnlyDates = false, now = new Date() } = {},
) {
  const groupsByDate = new Map(groupedOrders.map((group) => [group.date, group]));
  const todayKey = hidePastTimeOffOnlyDates ? formatLocalDateKey(now) : "";

  Object.entries(driverTimeOffByDate).forEach(([date, items]) => {
    if (
      !includeTimeOffOnlyDates ||
      (todayKey && DATE_KEY_PATTERN.test(date) && date < todayKey) ||
      !Array.isArray(items) ||
      items.length === 0 ||
      groupsByDate.has(date)
    ) {
      return;
    }

    groupsByDate.set(date, {
      date,
      label: formatDateLabel(date),
      orders: [],
    });
  });

  return Array.from(groupsByDate.values()).sort((a, b) => {
    if (a.date === "未设定日期") return 1;
    if (b.date === "未设定日期") return -1;
    return new Date(`${a.date}T00:00:00`) - new Date(`${b.date}T00:00:00`);
  });
}
